import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {ContainersModel} from "./containers.model";
import {ContainersService} from './containers.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-containers-form',
  templateUrl: './containers-form.component.html'
})
export class ContainersFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  conteiner: ContainersModel = new ContainersModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private containersService: ContainersService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      tipo: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      tamanho: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_container'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarConteiner');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarConteiner') : this.func.traduzir('front.cadastrarNovoConteiner');
      }

      if (!id) {
        return;
      }

      this.containersService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarConteiner')+': '+json.Payload[0].tipo + ' / '+json.Payload[0].tamanho;
            }else{
              this.title = this.func.traduzir('front.visualizarConteiner')+': '+json.Payload[0].tipo + ' / '+json.Payload[0].tamanho;
            }
            this.conteiner = json.Payload[0]
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.containersService.editar(values, values.id);
    } else {
      result = this.containersService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'containers']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/containers-form.component.ts